/* eslint-disable react/no-unescaped-entities */
import { Link } from "@tanstack/react-router";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import { InboxIcon } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";

interface LoginLinkSuccessModalProps {
  email: string;
  open: boolean;

  onClose(): void;
}

export function LoginLinkSuccessModal({
  email,
  open,
  onClose,
}: LoginLinkSuccessModalProps) {
  const { t } = useTranslation("login");

  return (
    <Dialog
      open={open}
      defaultOpen
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onClose();
        }
      }}
      modal={false}
    >
      <DialogContent
        className="px-[2.5rem] pt-[2.5rem] pb-[1rem] shadow-xl min-w-[30rem]"
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="relative mb-2">
            <InboxIcon className="h-14 w-14" strokeWidth={0.75} />
            <div className="bg-red-500 h-4 w-4 border-2 border-white rounded-full absolute bottom-1 -right-0" />
          </div>

          <DialogTitle className="text-2xl font-semibold tracking-[0.0075rem] text-secondary-800 px-[1rem]">
            {t("login:link.success.title")}
          </DialogTitle>
          <DialogDescription className="text-secondary-400 text-md font-light leading-6">
            <Trans
              t={t}
              i18nKey="login:link.success.description"
              values={{ email }}
              components={{ strong: <span className="font-semibold" /> }}
            />
          </DialogDescription>
        </DialogHeader>

        <hr />

        <div className="text-secondary-400 text-sm leading-5 font-light px-[1rem]">
          <Trans
            i18nKey="login:link.success.help"
            components={[
              <Link to="/login" className="text-primary-500 font-semibold" />, // eslint-disable-line
            ]}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
